import CheckmarkOutline20 from '@carbon/icons-react/es/checkmark--outline/20';
import ErrorOutline20 from '@carbon/icons-react/es/error--outline/20';
import Information20 from '@carbon/icons-react/es/information/20';
import Warning20 from '@carbon/icons-react/es/warning/20';
import React, { FC } from 'react';
import { useDocuments } from 'components/organisms/document/document-store';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import {
  DocumentInfoPanelTypes,
  INSERT_INFO_PANEL_COMMAND,
} from 'vendor/ckeditor/plugins/info-panel/constants';
import { ToolItem } from '../styled-components';

interface InfoPanelProps {
  icon: React.ReactNode;
  panelType: string;
}
const InfoPanel: FC<InfoPanelProps> = ({ icon, panelType }) => {
  const [state] = useDocuments();

  const executes = (type: string) => {
    state.editor?.execute(INSERT_INFO_PANEL_COMMAND, { paneltype: type });
    state.editor?.editing.view.focus();
  };

  return (
    <ToolItem onClick={() => executes(panelType)}>
      {icon}
      {useTranslation(`toolbar.info_panel_${panelType}` as TranslationKey)}
    </ToolItem>
  );
};

export const InsertInfoPanelDefault: FC = () => {
  return (
    <InfoPanel
      icon={<Information20 />}
      panelType={DocumentInfoPanelTypes.Info}
    />
  );
};

export const InsertInfoPanelWarning: FC = () => {
  return (
    <InfoPanel
      icon={<Warning20 />}
      panelType={DocumentInfoPanelTypes.Warning}
    />
  );
};

export const InsertInfoPanelError: FC = () => {
  return (
    <InfoPanel
      icon={<ErrorOutline20 />}
      panelType={DocumentInfoPanelTypes.Error}
    />
  );
};

export const InsertInfoPanelSuccess: FC = () => {
  return (
    <InfoPanel
      icon={<CheckmarkOutline20 />}
      panelType={DocumentInfoPanelTypes.Success}
    />
  );
};
